// Module
var code = "<md-toolbar> <div class=\"md-toolbar-tools lightbox-header\"> <h2 class=\"image-title set-ellipsis\"> {{documentPreviewToolbarVm.item.name}} </h2> <span flex></span> <document-preview-toolbar-buttons scope=documentPreviewToolbarVm /> </div> </md-toolbar> ";
// Exports
module.exports = code;